import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punerailwaystationcabservice() {



    const cardData = {

keyword: "Pune Railway Station Cab Service",

headingDescription:
    "Rising Cab Service offers dependable Pune Railway Station Cab Service for passengers, families, tourists, and business travelers. We provide 24/7 pickup and drop services from Pune Junction to hotels, homes, offices, Pune Airport, and outstation destinations. Our fleet includes Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional chauffeurs for a safe and comfortable journey. With on-time service, transparent pricing, and easy booking, Rising Cab Service ensures a smooth travel experience to and from Pune Railway Station.",

topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is one of the most popular destinations from Pune Railway Station, known for Gateway of India, Marine Drive, Juhu Beach, Siddhivinayak Temple, and major business hubs. Many travelers book direct cabs for comfortable onward journeys."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station famous for Bhushi Dam, Tiger Point, Rajmachi Fort, and lush green valleys. It is a favorite weekend getaway for passengers arriving at Pune Railway Station."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a renowned pilgrimage destination dedicated to Sai Baba. Visitors frequently hire cabs from Pune Railway Station for convenient and peaceful darshan trips."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a beautiful hill station known for Venna Lake, strawberry farms, and panoramic viewpoints, making it a popular holiday destination from Pune."
    },
    {
        title: "Goa",
        description:
            "Goa is a leading tourist destination famous for beaches, forts, churches, nightlife, and water sports. Travelers often choose cab services from Pune Railway Station for road trips to Goa."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a spiritual and cultural city known for Trimbakeshwar Jyotirlinga, Panchvati, Godavari Ghats, and vineyards, attracting pilgrims and tourists alike."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is one of the twelve Jyotirlingas of Lord Shiva and is surrounded by the scenic Sahyadri hills, making it a popular pilgrimage and nature destination."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for the UNESCO World Heritage Sites of Ajanta and Ellora Caves, along with Bibi Ka Maqbara and Daulatabad Fort, offering a rich historical experience."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is well known for the Mahalakshmi Temple, Panhala Fort, traditional cuisine, and rich Maratha heritage, making it a preferred outstation route from Pune."
    },
    {
        title: "Pandharpur",
        description:
            "Pandharpur is one of Maharashtra's most sacred pilgrimage destinations, home to the Shri Vitthal Rukmini Temple. Devotees regularly travel from Pune Railway Station for spiritual visits."
    }
],



services: [
    {
        name: "Pune Railway Station Cab",
        description:
            "Rising Cab Service offers Pune Railway Station Cab services for convenient pickup and drop transportation from Pune Junction to any destination in Pune or nearby cities. Our 24x7 cab service is ideal for business travelers, families, tourists, and daily commuters looking for safe and comfortable travel. We provide clean AC vehicles, professional drivers, transparent pricing, and instant as well as advance booking options for local and outstation journeys."
    },
    {
        name: "Cab Near Pune Railway Station",
        description:
            "Book a Cab Near Pune Railway Station with Rising Cab Service for quick and reliable transportation. Our nearby cabs are available for local travel, airport transfers, hotel pickups, and outstation trips with affordable fares and professional chauffeurs ensuring a smooth travel experience."
    },
    {
        name: "Taxi at Pune Station",
        description:
            "Rising Cab Service provides Taxi at Pune Station for passengers arriving or departing from Pune Junction. We offer comfortable and well-maintained vehicles for city rides, airport transfers, and long-distance travel with 24x7 availability and transparent pricing."
    },
    {
        name: "Railway Pickup Drop Pune",
        description:
            "Our Railway Pickup Drop Pune service ensures timely pickups and drops for train passengers with reliable drivers and comfortable AC vehicles. We provide stress-free transportation from Pune Railway Station to homes, hotels, offices, airports, and outstation destinations."
    },
    {
        name: "Cab from Pune Railway Station",
        description:
            "Rising Cab Service offers Cab from Pune Railway Station for local and outstation travel with safe drivers, clean vehicles, and affordable fares. Our service is suitable for individuals, families, and corporate travelers."
    },
    {
        name: "Pune Station Taxi Service",
        description:
            "Our Pune Station Taxi Service provides dependable transportation for passengers requiring local city rides, airport transfers, and outstation travel. Rising Cab Service ensures punctual pickups and comfortable journeys."
    },
    {
        name: "Affordable Station Cab Pune",
        description:
            "Rising Cab Service offers Affordable Station Cab Pune with budget-friendly fares for railway station pickups and drops. Our economical cab options provide safe and comfortable travel without hidden charges."
    },
    {
        name: "24 Hour Station Cab Pune",
        description:
            "Book 24 Hour Station Cab Pune with Rising Cab Service for round-the-clock railway transportation. Whether your train arrives early morning or late at night, our cabs are available 24x7."
    },
    {
        name: "Local Cab Near Station Pune",
        description:
            "Our Local Cab Near Station Pune service is perfect for short-distance travel within Pune including hotels, offices, shopping centers, and tourist attractions with affordable pricing."
    },
    {
        name: "Station Transfer Taxi Pune",
        description:
            "Rising Cab Service provides Station Transfer Taxi Pune for seamless travel between Pune Railway Station and airports, hotels, business centers, and residential areas with reliable service."
    },
    {
        name: "Best Cab Pune Railway Station",
        description:
            "Our Best Cab Pune Railway Station service combines affordability, safety, and punctuality to provide passengers with a premium railway transportation experience."
    },
    {
        name: "Budget Station Taxi Pune",
        description:
            "Rising Cab Service offers Budget Station Taxi Pune with economical travel options for railway passengers seeking affordable and reliable transportation."
    },
    {
        name: "Instant Cab Railway Station Pune",
        description:
            "Book Instant Cab Railway Station Pune with quick vehicle allocation and fast pickup service for urgent travel requirements from Pune Junction."
    },
    {
        name: "Sedan Cab Station Pune",
        description:
            "Our Sedan Cab Station Pune service offers comfortable and spacious vehicles for individuals and families traveling to and from Pune Railway Station."
    },
    {
        name: "SUV Cab Pune Station",
        description:
            "Rising Cab Service provides SUV Cab Pune Station for group travel and passengers with extra luggage, ensuring comfortable and spacious railway transportation."
    },
    {
        name: "Pune Railway Station Cab for Outstation",
        description:
            "Our Pune Railway Station Cab for Outstation offers direct travel from Pune Junction to destinations like Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, and other cities with experienced drivers."
    },
    {
        name: "Outstation Cab from Pune Railway Station",
        description:
            "Rising Cab Service provides Outstation Cab from Pune Railway Station with one-way and round-trip options for comfortable long-distance travel across Maharashtra and India."
    },
    {
        name: "Pune Station Taxi Service for Outstation",
        description:
            "Book Pune Station Taxi Service for Outstation with Rising Cab Service for safe and reliable intercity travel directly from Pune Railway Station."
    },
    {
        name: "Railway Station Outstation Cab Pune",
        description:
            "Our Railway Station Outstation Cab Pune service offers affordable and comfortable long-distance transportation with professional drivers and multiple vehicle options."
    },
    {
        name: "Pune Junction Outstation Cab Booking",
        description:
            "Rising Cab Service offers Pune Junction Outstation Cab Booking with instant confirmation and convenient travel solutions for business and leisure trips."
    },
    {
        name: "Pune Railway Station Taxi Booking",
        description:
            "Our Pune Railway Station Taxi Booking service allows passengers to reserve cabs in advance or instantly for local and outstation travel with transparent pricing."
    },
    {
        name: "Best Outstation Cab from Pune Station",
        description:
            "Rising Cab Service provides the Best Outstation Cab from Pune Station with comfortable vehicles, experienced chauffeurs, and flexible travel packages."
    },
    {
        name: "24x7 Pune Railway Station Cab",
        description:
            "Book 24x7 Pune Railway Station Cab with Rising Cab Service for dependable transportation any time of the day or night with quick response and professional service."
    },
    {
        name: "Cheap Outstation Cab Pune Railway Station",
        description:
            "Our Cheap Outstation Cab Pune Railway Station offers budget-friendly intercity travel with safe drivers and well-maintained vehicles for comfortable journeys."
    },
    {
        name: "Pune Station to Mumbai Cab Service",
        description:
            "Rising Cab Service offers Pune Station to Mumbai Cab Service with one-way and round-trip options for business travel, airport transfers, and family trips."
    },
    {
        name: "Best Outstation Cab Near Pune Railway Station",
        description:
            "Looking for the Best Outstation Cab Near Pune Railway Station? Rising Cab Service provides affordable and reliable intercity transportation with multiple vehicle choices."
    },
    {
        name: "Cheap Taxi from Pune Station",
        description:
            "Our Cheap Taxi from Pune Station provides economical local and outstation transportation with transparent pricing and professional drivers."
    },
    {
        name: "Book Outstation Cab from Pune Railway Station",
        description:
            "Book Outstation Cab from Pune Railway Station with Rising Cab Service for convenient and comfortable long-distance travel with instant booking facilities."
    },
    {
        name: "Safe Cab Service Pune Station",
        description:
            "Rising Cab Service offers Safe Cab Service Pune Station with verified drivers, GPS-enabled vehicles, and dependable transportation for all passengers."
    },
    {
        name: "Railway Station Pickup Cab Pune",
        description:
            "Our Railway Station Pickup Cab Pune provides timely pickups from Pune Junction with comfortable vehicles and professional chauffeurs for local and outstation travel."
    },
    {
        name: "Cab from Pune Junction to Mumbai",
        description:
            "Rising Cab Service provides Cab from Pune Junction to Mumbai with affordable fares, experienced highway drivers, and comfortable AC vehicles for safe intercity travel."
    }
],

tableData: [
    ["Pune Railway Station Cab", "Cab Near Pune Railway Station"],
    ["Taxi at Pune Station", "Railway Pickup Drop Pune"],
    ["Cab from Pune Railway Station", "Pune Station Taxi Service"],
    ["Affordable Station Cab Pune", "24 Hour Station Cab Pune"],
    ["Local Cab Near Station Pune", "Station Transfer Taxi Pune"],
    ["Best Cab Pune Railway Station", "Budget Station Taxi Pune"],
    ["Instant Cab Railway Station Pune", "Sedan Cab Station Pune"],
    ["SUV Cab Pune Station", "Pune Railway Station Cab for Outstation"],
    ["Outstation Cab from Pune Railway Station", "Pune Station Taxi Service for Outstation"],
    ["Railway Station Outstation Cab Pune", "Pune Junction Outstation Cab Booking"],
    ["Pune Railway Station Taxi Booking", "Best Outstation Cab from Pune Station"],
    ["24x7 Pune Railway Station Cab", "Cheap Outstation Cab Pune Railway Station"],
    ["Pune Station to Mumbai Cab Service", "Best Outstation Cab Near Pune Railway Station"],
    ["Cheap Taxi from Pune Station", "Book Outstation Cab from Pune Railway Station"],
    ["Safe Cab Service Pune Station", "Railway Station Pickup Cab Pune"],
    ["Cab from Pune Junction to Mumbai", "Pune Railway Station Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Convenient Pune Railway Station Cab Service",
        WhyChoosedescription: "Rising Cab Service provides dependable cab transportation to and from Pune Railway Station for travelers, families, tourists, students, and business professionals."
    },
    {
        WhyChooseheading: "Timely Pickup and Drop Assistance",
        WhyChoosedescription: "Our drivers ensure punctual arrivals and departures, helping passengers reach the railway station without unnecessary delays or travel stress."
    },
    {
        WhyChooseheading: "Perfect for Train Travelers",
        WhyChoosedescription: "Whether arriving in Pune or departing for another city, our cab service offers a comfortable and hassle-free travel experience."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles depending on passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Coverage Across Pune and PCMC",
        WhyChoosedescription: "We provide pickup and drop services from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Comfortable Travel with Luggage Support",
        WhyChoosedescription: "Our vehicles offer ample luggage space and comfortable seating, making railway station transfers smooth for individuals and families."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Travelers",
        WhyChoosedescription: "The service is ideal for tourists, corporate guests, students, senior citizens, and travelers connecting to other destinations from Pune."
    },
    {
        WhyChooseheading: "Reliable Service Throughout the Year",
        WhyChoosedescription: "Rising Cab Service operates during weekdays, weekends, holidays, and festive seasons to meet all railway transportation needs."
    }
]
};

const faqData = [
    {
        question: "Can I book a cab for Pune Railway Station pickup?",
        answer: "Yes, Rising Cab Service provides pickup services for passengers arriving at Pune Railway Station."
    },
    {
        question: "Do you offer drop services to Pune Railway Station?",
        answer: "Yes, customers can schedule timely drop services from any Pune or PCMC location to the railway station."
    },
    {
        question: "Are cabs available for early morning and late-night train schedules?",
        answer: "Yes, railway station cab services can be arranged according to train arrival and departure timings."
    },
    {
        question: "Which areas are covered for railway station transfers?",
        answer: "Our services cover Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding locations."
    },
    {
        question: "Can families book larger vehicles for station transfers?",
        answer: "Yes, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are available for families and groups carrying luggage."
    },
    {
        question: "Do business travelers use railway station cab services?",
        answer: "Yes, many professionals and corporate travelers use our service for convenient transportation to and from Pune Railway Station."
    },
    {
        question: "Is advance booking recommended for railway station travel?",
        answer: "Yes, advance booking helps ensure vehicle availability and timely transportation."
    },
    {
        question: "Can tourists arrange sightseeing after railway station pickup?",
        answer: "Yes, customized travel plans and Pune sightseeing tours can be arranged after pickup."
    },
    {
        question: "Are one-way transfers available for railway station travel?",
        answer: "Yes, customers can book one-way pickups and drops as per their travel requirements."
    },
    {
        question: "How can I reserve a Pune Railway Station Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Shashank Patil",
        feedback:
            "Reaching Pune Railway Station for an early morning train was completely hassle-free. The cab arrived before schedule, and the journey was smooth and comfortable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Deepali Kulkarni",
        feedback:
            "After arriving at Pune Railway Station with family and luggage, the pickup arrangement was perfectly managed. The vehicle was spacious, and the driver was very helpful.",
        rating: 5
    }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Railway Station Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-railway-station-cab-service.jpg",
"description": "Book Pune Railway Station Cab Service with Rising Cab Service for reliable pickup and drop, local travel, and outstation trips. Enjoy 24x7 affordable taxi service from Pune Railway Station with professional drivers and comfortable AC cabs.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-railway-station-cab-service"
}
};








    return (
        <div>

<Helmet>
  <title>Pune Railway Station Cab Service | Pickup & Drop Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Railway Station Cab Service for pickup and drop, local travel, and outstation trips. Affordable 24x7 taxi service with AC cabs and professional drivers at Pune Station."
/>

<meta
 name="keywords"
 content="Pune railway station cab, cab near pune railway station, taxi at pune station, railway pickup drop pune, cab from pune railway station, pune station taxi service, affordable station cab pune, 24 hour station cab pune, local cab near station pune, station transfer taxi pune, best cab pune railway station, budget station taxi pune, instant cab railway station pune, sedan cab station pune, suv cab pune station, Pune Railway Station Cab for Outstation, Outstation Cab from Pune Railway Station"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punerailwaystationcabservice;